import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  resetForm,
  getProjectById,
  modifyProject,
  modifyCustomField, //Groups
  addProject,
  updateProject,
} from 'projects/actions';

import { getEditing } from 'projects/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';
import { addGrowlError, addGrowlSuccess } from 'messages/actions';

import { getCustomFieldsEmployees } from 'custom_fields_employees/actions'; //Groups
import { getGroups } from 'groups/actions'; //Groups

import { valueFromEvent, createRoute } from 'lib/util';

class ProjectsFormHandlers extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
  };

  state = { isSubmitted: false, isValid: false, isSaving: false };

  componentWillMount = () => {
    const { pid } = this.props.match.params;
    this.props.reset();
    pid && this.props.getById(pid, this.props.company.id, this.props.subcompany.id);
    //Groups
    this.props.getCustomFields(this.props.company.id, this.props.subcompany.id);
    const filters = { fulltext: 'proyecto', columnSearch: ['module'] }; // Filtros para traer solo los grupos de empleados
    this.props.getGroups(this.props.company.id, this.props.subcompany.id, filters);
    //Groups
  };

  handleSubmit = ({ isValid }) => {
    this.setState({ isSubmitted: true, isValid, isSaving: true }, () => {
      if (isValid) {
        const promise = this.props.project.id
          ? this.props.update(
              this.props.project.id,
              this.props.company.id,
              this.props.subcompany.id,
              this.props.project
            )
          : this.props.add(this.props.company.id, this.props.subcompany.id, this.props.project);

        promise
          .then(({ value }) => {
            this.props.success(value.message);
            this.props.history.push(
              createRoute(this.props.company.id, this.props.subcompany.id, 'projects')
            );
          })
          .catch((err) => {
            this.props.error(err.message);
            this.finishSaving();
          });
      } else {
        this.props.error('error.verify');
        this.finishSaving();
      }
    });
  };

  finishSaving = () => this.setState({ isSaving: false });

  //handleValueChange = e => this.props.modify(valueFromEvent(e));

  handleValueChange = (e) => {
    let payload = valueFromEvent(e);
    payload = Object.keys(payload).reduce((re, k) => {
      if (k.indexOf('amount') > -1) {
        re[k] = parseFloat(payload[k]);
        re[k] = re[k] || '';
      } else {
        re[k] = payload[k];
      }
      return re;
    }, {});

    this.props.modify(payload);
  };

  //Groups
  handleGroupChange = (e) => {
    const { value } = e.target;
    let _group = [{ _id: value }];
    if (value == 'null' || value == '' || value == null || value == undefined) _group = [];
    this.props.modify({ _group });
  };

  handleCustomFieldChange = (e) => this.props.modifyCustomField(valueFromEvent(e)); // Especial para custom fields
  //Groups

  handleValidation = (isValid) => this.setState({ isValid });

  render = () =>
    this.props.render({
      isSaving: this.state.isSaving,
      isSubmitted: this.state.isSubmitted,
      handleSubmit: this.handleSubmit,
      handleValueChange: this.handleValueChange,
      handleCustomFieldChange: this.handleCustomFieldChange, //Groups
      handleGroupChange: this.handleGroupChange, //Groups
      handleValidation: this.handleValidation,
    });
}

const mapStateToProps = (state) => ({
  project: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

const mapDispatchToProps = {
  add: addProject,
  error: addGrowlError,
  getById: getProjectById,
  modify: modifyProject,
  getCustomFields: getCustomFieldsEmployees, //Groups
  getGroups: getGroups, //Groups
  modifyCustomField: modifyCustomField, //Groups
  reset: resetForm,
  success: addGrowlSuccess,
  update: updateProject,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectsFormHandlers));



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/containers/ProjectFormHandlers.js